import DashboardLayout from '@/layouts/DashboardLayout'

import Home from '@/views/Home'
import Login from '@/views/Login'

import siteVersions from '@/app/site-versions/routes'
import products from '@/app/products/routes'
import riders from '@/app/riders/routes'
import fighters from '@/app/fighters/routes'
import rappers from '@/app/rappers/routes'
import news from '@/app/news/routes'
import socials from '@/app/socials/routes'
import contacts from '@/app/contacts/routes'
import cities from '@/app/cities/routes'
import feedback from '@/app/feedback/routes'
import faqs from '@/app/faqs/routes'

import errors from './errors'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    meta: { auth: true },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      ...siteVersions,
      ...products,
      ...riders,
      ...fighters,
      ...rappers,
      ...news,
      ...socials,
      ...contacts,
      ...cities,
      ...feedback,
      ...faqs
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { auth: false }
  },
  ...errors
]

export default routes
